import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

import logo1 from '../assets/proctored-logos/proctored-logo-1.png';
import logo2 from '../assets/proctored-logos/proctored-logo-2.png';
import logo3 from '../assets/proctored-logos/proctored-logo-3.png';
import logo4 from '../assets/proctored-logos/proctored-logo-4.png';
import logo5 from '../assets/proctored-logos/proctored-logo-5.png';
import logo6 from '../assets/proctored-logos/proctored-logo-6.png';
import logo7 from '../assets/proctored-logos/proctored-logo-7.png';
import logo8 from '../assets/proctored-logos/proctored-logo-8.png';
import logo9 from '../assets/proctored-logos/proctored-logo-9.png';
import logo10 from '../assets/proctored-logos/proctored-logo-10.png';
import logo11 from '../assets/proctored-logos/proctored-logo-11.png';
import logo12 from '../assets/proctored-logos/proctored-logo-12.png';
import logo13 from '../assets/proctored-logos/proctored-logo-13.png';
import logo14 from '../assets/proctored-logos/proctored-logo-14.png';
import aboutUsImg from '../assets/about-us.jpg';
import subjectsImg from '../assets/subjects-we-cover.jpg';

const {
  FiShield,
  FiUsers,
  FiAward,
  FiClock,
  FiCheckCircle,
  FiStar,
  FiTarget,
  FiBook,
  FiTrendingUp,
  FiMessageCircle,
  FiArrowRight
} = FiIcons;

const OnlineExamHelp = () => {
  const whyChooseUs = [
    {
      icon: FiUsers,
      title: 'Personalized Assistance',
      description:
        'We match you with tutors who specialize in your subject area, ensuring you receive the most relevant and effective support.'
    },
    {
      icon: FiShield,
      title: 'Guaranteed Pass Support',
      description:
        'We are committed to your success. Our proven strategies and resources aim to help you not only prepare but also pass your exams with confidence.'
    },
    {
      icon: FiAward,
      title: 'Expert Tutors',
      description:
        'Our team consists of specialists across all major course subjects, bringing a wealth of knowledge and experience to your study sessions.'
    }
  ];

  const examTypes = [
    {
      icon: FiBook,
      title: 'Standardized Tests',
      description: 'SAT, ACT, GRE, GMAT, LSAT, MCAT — comprehensive prep for every major standardized exam in the US.'
    },
    {
      icon: FiTarget,
      title: 'Course-Specific Exams',
      description: 'Midterms, finals, and quizzes across all university and college subjects — we cover them all.'
    },
    {
      icon: FiTrendingUp,
      title: 'Professional Certification',
      description: 'CPA, CFA, PMP, NCLEX, Bar Exam prep — guided by certified professionals in their respective fields.'
    },
    {
      icon: FiMessageCircle,
      title: 'Online Proctored Exams',
      description: 'Support and strategies for Respondus, ProctorU, Honorlock, and all major online proctoring platforms.'
    },
    {
      icon: FiClock,
      title: 'Time Management Coaching',
      description: 'Learn how to tackle timed exams effectively — pacing strategies, question prioritization, and more.'
    },
    {
      icon: FiShield,
      title: 'Practice & Mock Exams',
      description: 'Simulate real exam conditions with our customized mock tests, detailed feedback, and performance analytics.'
    }
  ];

  const subjects = [
    'Mathematics & Statistics – Algebra, Calculus, Probability, Data Analysis',
    'Science – Physics, Chemistry, Biology, Environmental Science',
    'Business & Economics – Accounting, Finance, Marketing, Management',
    'Computer Science & IT – Programming, Data Science, Networking',
    'Humanities & Social Sciences – History, Sociology, Psychology, Political Science',
    'Pre-Med & Health Sciences – Anatomy, Pharmacology, Pathology',
    'Law & Legal Studies – Constitutional Law, Contracts, Criminal Law',
    'Languages & Writing – English, Academic Writing, ESL Exam Prep'
  ];

  const howItWorks = [
    {
      number: '1',
      title: 'Tell Us Your Exam Details',
      description: 'Share your exam subject, date, format, and any specific topics you need help with.'
    },
    {
      number: '2',
      title: 'Get Matched with an Expert',
      description: 'We connect you with a tutor who specializes in your exact subject and exam format.'
    },
    {
      number: '3',
      title: 'Prepare & Pass with Confidence',
      description: 'Follow your personalized study plan, take mock exams, and walk into your exam fully prepared.'
    }
  ];

  const testimonials = [
    {
      text: "I was terrified of my GMAT, but Tutor Hub Online's exam prep sessions were incredible. My tutor knew every trick in the book. I scored 720!",
      author: 'Michael R.',
      location: 'New York, US',
      rating: 5
    },
    {
      text: "Thanks to their personalized approach, I finally passed my NCLEX on the first attempt. The guaranteed pass support is no joke — they really deliver!",
      author: 'Ashley T.',
      location: 'Texas, US',
      rating: 5
    }
  ];

  const stats = [
    { value: '95%', label: 'Pass Rate' },
    { value: '500+', label: 'Exams Covered' },
    { value: '1,200+', label: 'Students Helped' },
    { value: '24/7', label: 'Support Available' }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              Online Exam Help US – Expert Exam Preparation
            </h1>
            <h2 className="text-xl lg:text-2xl text-blue-100 mb-8 max-w-4xl mx-auto">
              Your dedicated partner in exam preparation. Personalized, one-on-one support tailored to your specific needs — from standardized tests to course finals.
            </h2>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/book-tutor"
                className="bg-accent text-black px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors"
              >
                👉 Book Exam Help Now
              </Link>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-primary transition-colors"
              >
                👉 Free Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-gray-900 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-1">
                <div className="text-3xl font-bold text-accent">{stat.value}</div>
                <div className="text-gray-400 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* About Us Image */}
            <div className="w-full h-96 rounded-2xl overflow-hidden order-2 lg:order-1">
              <img src={aboutUsImg} alt="About Us - Tutorhub Online" className="w-full h-full object-cover" />
            </div>

            <div className="space-y-6 order-1 lg:order-2">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">About Us</h2>
              <p className="text-gray-600 text-lg">
                Welcome to <strong>Tutorhub Online</strong>, your dedicated partner in exam preparation. We understand
                that navigating the challenges of academic exams can be daunting, which is why we offer personalized,
                one-on-one support tailored to your specific needs.
              </p>
              <p className="text-gray-600">
                Our mission is to empower students across the U.S. by providing expert guidance and resources for all
                major exams. Whether you're gearing up for a standardized test or a course-specific assessment, our
                experienced tutors are here to help you achieve your goals.
              </p>
              <p className="text-gray-700 font-medium">
                At Tutorhub Online, we believe that every student deserves the opportunity to succeed. Let us help you
                unlock your potential and achieve the results you desire.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center text-primary font-semibold hover:text-blue-700 transition-colors group"
              >
                Ready to get started? Contact us today!
                <SafeIcon icon={FiArrowRight} className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Choose Us?</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We don't just prepare you — we guarantee your success with personalized, expert-led exam support.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 text-center group"
              >
                <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-5 group-hover:bg-primary/20 transition-colors">
                  <SafeIcon icon={item.icon} className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Exam Types We Cover */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Exams We Help With</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              From standardized tests to professional certifications, we cover every type of exam US students face.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {examTypes.map((exam, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:border-primary/30 hover:shadow-md transition-all duration-300"
              >
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <SafeIcon icon={exam.icon} className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{exam.title}</h3>
                <p className="text-gray-600 text-sm">{exam.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subjects Section */}
      <section className="py-16 bg-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-gray-900">Subjects We Cover</h2>
              <p className="text-gray-600">
                Our expert tutors span virtually every discipline taught at US colleges and universities.
              </p>
              <div className="space-y-3">
                {subjects.map((subject, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{subject}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Subjects Image */}
            <div className="w-full h-96 rounded-2xl overflow-hidden">
              <img src={subjectsImg} alt="Subjects We Cover" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-primary text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-blue-600 to-blue-800" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">How It Works — 3 Simple Steps</h2>
            <p className="text-blue-100 max-w-2xl mx-auto">
              Getting started with your exam prep is quick and easy.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {howItWorks.map((step, index) => (
              <div key={index} className="text-center relative">
                <div className="w-16 h-16 bg-accent text-black rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                  {step.number}
                </div>
                {index < howItWorks.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-white/30 -z-10" />
                )}
                <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                <p className="text-blue-100">{step.description}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/book-tutor"
                className="bg-accent text-black px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors"
              >
                👉 Book Exam Help Now
              </Link>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-primary transition-colors"
              >
                👉 Free Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testing Platforms Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Professional Exam Help for All Online Testing Platforms
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto text-lg">
              Our team of experts is ready to assist with your exams, no matter the platform. We'll help you get those good grades you're aiming for with our online exam help.
            </p>
          </div>

          {/* Row 1 — 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {/* ExamView */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo12} alt="ExamView" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">ExamView</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Need some help with an ExamView test? Our online exam helpers are ready to take your exam and help you do your best.
              </p>
            </div>

            {/* ExamShield */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo13} alt="ExamShield" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">ExamShield</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                If you're taking a test on ExamShield, we can assist you. Just say take my online exam and we will help you get those top grades.
              </p>
            </div>

            {/* ProctorExam / Exam Guardian */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo14} alt="ProctorExam" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Exam Guardian</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We provide exam assistance for ProctorExam Guardian. Our exam takers are ready to help with your online test.
              </p>
            </div>
          </div>

          {/* Row 2 — 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {/* Respondus */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo1} alt="Respondus" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Respondus Lockdown Browser</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Got a Respondus exam coming up? We can help with exam needs! Our exam takers are here to handle your online quiz or even that big final exam for you.
              </p>
            </div>

            {/* Pearson VUE */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo2} alt="Pearson VUE" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Pearson VUE</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                If you have a Pearson VUE test coming up, we can provide exam assistance. Let us take your online exam, and we will make sure you have time to spare without feeling stressed.
              </p>
            </div>

            {/* ProctorU */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo3} alt="ProctorU" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">ProctorU</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Need a hand with a ProctorU exam? Our online exam helpers can step in, take your test for me, and work hard to get you those good grades.
              </p>
            </div>
          </div>

          {/* Row 3 — 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {/* Proctorio */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo4} alt="Proctorio" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Proctorio</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Got a Proctorio exam? Don't worry, we can handle it. Our exam takers will take your online exam for you and help you get those high scores.
              </p>
            </div>

            {/* PSI */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo5} alt="PSI" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">PSI</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Taking a PSI exam soon? We can assist with your online test and make sure you're all set to do well with exam help online.
              </p>
            </div>

            {/* Examity */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo6} alt="Examity" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Examity</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We also provide exam help online for Examity. Just say take my exam for me, and we'll work toward getting you great results.
              </p>
            </div>
          </div>

          {/* Row 4 — 3 cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {/* HonorLock */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo7} alt="HonorLock" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">HonorLock</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We offer help with exam for Honorlock exams. Hire someone to take my online exam and make things easier for you.
              </p>
            </div>

            {/* Examplify */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo8} alt="Examplify" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Examplify</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Need support for an Examplify test? Our live exam helpers can take your exam and help you succeed.
              </p>
            </div>

            {/* SmarterProctoring */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo9} alt="SmarterProctoring" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">SmarterProctoring</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Need someone to handle your SmarterProctoring exam for you? We are ready to assist with online exam help services. We will take your online exam and try hard to help you succeed.
              </p>
            </div>
          </div>

          {/* Row 5 — 2 cards centered */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {/* DigiExam */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo10} alt="DigiExam" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">DigiExam</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                We offer online exam help services for DigiExam too. If you need us to take my online test, we'll do it and help you get the results you're hoping for.
              </p>
            </div>

            {/* ExamSoft */}
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-primary/20">
              <div className="h-20 flex items-center justify-center mb-5">
                <img src={logo11} alt="ExamSoft" className="h-14 max-w-full object-contain" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Examsoft</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                For ExamSoft exams, our team of experts is ready to help. We can take your online test and aim for top grades on your behalf.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">What Our Students Say</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Real results from real students across the United States.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300">
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-600 mb-4 italic text-lg">"{testimonial.text}"</p>
                <div>
                  <p className="text-gray-900 font-semibold">– {testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            🎯 Ready to Pass Your Exam with Confidence?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Join over 1,200+ US students who trusted Tutorhub Online to help them prepare, perform, and pass. Contact us today and take the first step toward exam success!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/book-tutor"
              className="bg-accent text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-colors text-lg"
            >
              👉 Book Your Exam Help Today!
            </Link>
            <Link
              to="/contact"
              className="border-2 border-gray-600 text-white px-8 py-4 rounded-lg font-semibold hover:border-white transition-colors text-lg"
            >
              📩 Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OnlineExamHelp;
